import {
  IssueFragment,
  StartIssueMutation,
  StartIssueMutationVariables,
  useStartIssueMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useStartIssue = withStandardMutationHook<
  StartIssueMutation,
  IssueFragment,
  StartIssueMutationVariables,
  'startIssue',
  [string]
>(useStartIssueMutation, 'startIssue', name => ({
  name,
}));
